// extracted by mini-css-extract-plugin
export var addressFields = "_n3-0";
export var animationContainer = "_n3-1";
export var footer = "_n3-2";
export var lineItems = "_n3-3";
export var modalContent = "_n3-4";
export var orderName = "_n3-5";
export var strong = "_n3-6";
export var warning = "_n3-7";